import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { memo } from "react";

// TODO(karlbernard): [NX-11136] Replace with CMS keys (subscription:page.landing.testimonials*) once registered.
const EYEBROW = "Loved by members";
const TITLE = "You're in good company";
const STARS = "★★★★★";

type Testimonial = {
  readonly name: string;
  readonly body: string;
};

type TestimonialsSectionProps = {
  readonly testimonials: readonly Testimonial[];
};

function TestimonialsSection({ testimonials }: TestimonialsSectionProps) {
  return (
    <section className="pb-2 pt-7 md:pt-12 md:text-center" data-testid="TestimonialsSection">
      <Text className="block tracking-[0.16em] uppercase text-blue-600 dark:text-blue-400 mb-2">{EYEBROW}</Text>
      <Text
        variant={TextVariants.HEADING_4_BOLD}
        className="block md:text-[30px] tracking-tight text-gray-900 dark:text-white mb-[18px] md:mb-7 text-balance"
      >
        {TITLE}
      </Text>

      <div className="flex flex-col gap-2.5 md:flex-row md:gap-4">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.name}
            className="flex-1 rounded-2xl border border-gray-100 bg-gray-50 dark:border-white/[0.06] dark:bg-[#101014] px-[18px] py-4 text-left"
            data-testid={`TestimonialsSection-${testimonial.name.replace(/\s+/g, "")}`}
          >
            <div className="text-[#ffb947] text-[13px] tracking-[2px] mb-2" aria-label="5 stars" role="img">
              {STARS}
            </div>
            <Text variant={TextVariants.PARAGRAPH_MEDIUM_REGULAR} className="block text-gray-600 dark:text-white/80 leading-relaxed mb-2.5">
              {testimonial.body}
            </Text>
            <Text className="block text-xs text-gray-600 dark:text-white/55">{testimonial.name}</Text>
          </div>
        ))}
      </div>
    </section>
  );
}

export default memo(TestimonialsSection);
